module.exports = __webpack_public_path__ + "img/icons8-approval 1.fdafabd8.svg";